var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 23,
    viewBox: "0 0 11 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.74917V16.3292C9.5 18.4192 7.97 20.2792 5.89 20.4792C3.5 20.7092 1.5 18.8392 1.5 16.4992V4.13917C1.5 2.82917 2.44 1.63917 3.74 1.50917C5.24 1.35917 6.5 2.52917 6.5 3.99917V14.4992C6.5 15.0492 6.05 15.4992 5.5 15.4992C4.95 15.4992 4.5 15.0492 4.5 14.4992V5.74917C4.5 5.33917 4.16 4.99917 3.75 4.99917C3.34 4.99917 3 5.33917 3 5.74917V14.3592C3 15.6692 3.94 16.8592 5.24 16.9892C6.74 17.1392 8 15.9692 8 14.4992V4.16917C8 2.07917 6.47 0.219169 4.39 0.0191695C2.01 -0.210831 0 1.65917 0 3.99917V16.2692C0 19.1392 2.1 21.7092 4.96 21.9792C8.25 22.2792 11 19.7192 11 16.4992V5.74917C11 5.33917 10.66 4.99917 10.25 4.99917C9.84 4.99917 9.5 5.33917 9.5 5.74917Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.831e1cd09b87ded716de15df743ec9eb.svg";
export { ForwardRef as ReactComponent };